<script setup>
import axios from 'axios';
import { ref, onMounted, onUnmounted } from 'vue';
import { modalUtil } from '@functions/modalUtil';
import { url } from '@/config/urls';

// 外部定義メソッド
const { switchFromCurrentModal } = modalUtil();

const emit = defineEmits(['updateLoading', 'getGoodsFavorites', 'apiError']);

const props = defineProps({
  goodsFavorites: {
    type: Array,
    required: true
  },
  hasFavoriteSlot: {
    type: Boolean,
    required: true
  },
  orderNumber: {
    type: Number,
    default: null
  },
  orderFavoriteAddApiUrl: {
    type: String,
    default: url.api.orderFavorite.add
  },
  orderToFavoriteApiUrl: {
    type: String,
    default: url.api.orderToFavorite
  }
});

const newGoodsFavName = ref('');
const checkedGoodsFavIds = ref([]);

const updateCheckedGoodsFavIds = (event, value) => {
  if (event.target.checked && !checkedGoodsFavIds.value.includes(value)) {
    checkedGoodsFavIds.value.push(value);
  } else if (!event.target.checked && checkedGoodsFavIds.value.includes(value)) {
    const index = checkedGoodsFavIds.value.indexOf(value);
    checkedGoodsFavIds.value.splice(index, 1);
  }
}
// 「追加」押下時処理
const addFavorite = () => {
  if (newGoodsFavName.value.trim() === '') {
    return;
  }
  emit('updateLoading', true);
  axios.post(props.orderFavoriteAddApiUrl, {
    goodsFavName: newGoodsFavName.value
  })
    .then((response) => {
      // do nothing
    })
    .catch((error) => {
      emit('apiError', error);
    })
    .finally(() => {
      emit('getGoodsFavorites');
      newGoodsFavName.value = '';
      emit('updateLoading', false);
    });
}

// 「登録する」押下時処理
const addToFavorite = () => {
  emit('updateLoading', true);
  const param = {
    goodsFavIdList: checkedGoodsFavIds.value,
    orderNumber: props.orderNumber
  };
  axios.post(props.orderToFavoriteApiUrl, param)
    .then((response) => {
      switchFromCurrentModal('addToFavoriteCompleteModal');
    })
    .catch((error) => {
      emit('apiError', error);
    })
    .finally(() => {
      emit('updateLoading', false);
    });
}

// 「戻る」押下時処理
const backToOrderCompleteModal = () => {
  switchFromCurrentModal('orderCompleteModal');
}

// フォームを初期化する関数
const initializeForm = () => {
  newGoodsFavName.value = '';
  checkedGoodsFavIds.value = [];
};

onMounted(() => {
  // 初回マウント時の初期化
  initializeForm();
  
  // モーダルが開いたときのイベントリスナーを追加
  const modalElement = document.getElementById('addToFavoriteModal');
  if (modalElement) {
    modalElement.addEventListener('shown.bs.modal', initializeForm);
  }
});

// コンポーネント破棄時にイベントリスナーを削除
onUnmounted(() => {
  const modalElement = document.getElementById('addToFavoriteModal');
  if (modalElement) {
    modalElement.removeEventListener('shown.bs.modal', initializeForm);
  }
});

const onInputGoodsFavName = () => {
      // 20文字までの入力制限
      const chars = Array.from(newGoodsFavName.value);
      if (chars.length > 20) {
        newGoodsFavName.value = chars.slice(0, 20).join('');
      }
  }
</script>

<template>
  <div class="modal com_modal2 fade" id="addToFavoriteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1">登録したいお気に入りグループを選択してください</h3>
          <div class="com_add_fabo1">
            <div v-for="fav in props.goodsFavorites" :key="fav.id">
              <div class="com_form_check1">
                <input type="checkbox" @change="updateCheckedGoodsFavIds($event, fav.id)">
                <label>{{ fav.name }}</label>
              </div>
            </div>
            <div class="group1" v-if="props.goodsFavorites.length < 5">
              <input type="text" placeholder="お気に入り名を入力してください"
                     class="form-control com_form1" v-model="newGoodsFavName" @input="onInputGoodsFavName">
              <button type="button" class="btn com_btn9" @click="addFavorite" :disabled="newGoodsFavName.trim() === ''">追加</button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" @click="addToFavorite" :disabled="checkedGoodsFavIds.length === 0 || props.orderNumber === null">登録する</button>
          <button type="button" class="btn com_btn2" @click="backToOrderCompleteModal">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>
